import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { ChainWideFortigatesComponent } from '@app/features/fortigates/modules/chain-wide-fortigates/chain-wide-fortigates.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        ChainWideFortigatesComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class ChainWideFortigatesModule {}